import React from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox } from 'antd'
import { Link } from 'react-router-dom'
import { MailIcon } from 'components/Icons'
import {
  DomiciliationMailsHeader,
  DomiciliationName,
  DomiciliationSociety,
  DomiciliationForwardingAddress,
  DomiciliationInfosMobile,
  DomiciliationMailsTotal,
  MobileMailsNumber
} from './styles'
import { MailsByDomiciliations } from 'globals/models/Mail'

interface IProps {
  selectedDomiciliationsIds: React.Key[]
  mails: MailsByDomiciliations,
  onToggleDomiciliationCheckbox: any,
  hideCheckbox: boolean
}

const DomiciliationHeaderLine = (props: IProps) => {
  const { selectedDomiciliationsIds, mails, onToggleDomiciliationCheckbox } = props
  const { t } = useTranslation()

  return (
    <DomiciliationMailsHeader selected={selectedDomiciliationsIds.includes(mails.domiciliation.id)}>
      { !props.hideCheckbox &&
        <Checkbox
          checked={selectedDomiciliationsIds.includes(mails.domiciliation.id)}
          onChange={ onToggleDomiciliationCheckbox(mails.domiciliation.id) }
        />
      }

      <DomiciliationName>
        <Link to={`/client/${mails.domiciliation.id}`}>
          {mails.domiciliation.firstname}
          &nbsp;
          {mails.domiciliation.lastname}
        </Link>
      </DomiciliationName>

      <DomiciliationSociety>
        {mails.domiciliation.society.name}
      </DomiciliationSociety>

      <DomiciliationForwardingAddress>
        {mails.forwardingAddress.streetAddress}
          &nbsp;
        {mails.forwardingAddress.postalCode}
          &nbsp;
        {mails.forwardingAddress.city}
      </DomiciliationForwardingAddress>

      <DomiciliationInfosMobile>

        <DomiciliationName>
          {mails.domiciliation.firstname}
          &nbsp;
          {mails.domiciliation.lastname}
        </DomiciliationName>

        <DomiciliationSociety>
          {mails.domiciliation.society.name}
        </DomiciliationSociety>

        <DomiciliationForwardingAddress>
          {mails.forwardingAddress.streetAddress}
          &nbsp;
          {mails.forwardingAddress.postalCode}
          &nbsp;
          {mails.forwardingAddress.city}
        </DomiciliationForwardingAddress>
      </DomiciliationInfosMobile>

      <DomiciliationMailsTotal>
        <MobileMailsNumber>
          {mails.userMailsCount}
        </MobileMailsNumber>

        <MailIcon />
        <span className="mails-count">{mails.userMailsCount}</span>
        <span className="mobile-hide">
          { mails.userMailsCount > 1 && t('mails.mails-available')}
          { mails.userMailsCount === 1 && t('mails.mail-available')}
        </span>
        <span className="mobile-display">
          <MailIcon />
        </span>

      </DomiciliationMailsTotal>
    </DomiciliationMailsHeader>
  )
}

export default DomiciliationHeaderLine
